import mutations from './mutations';
import actions from './actions';
// import moment from 'moment';

export default {
  namespaced: true,
  modules: {
  },
  state: {
    templates: [],
    templates_dropdown: [],
    templates_count: 0,
    deleted_template: {
      data: {},
      message: '',
      status: 'loading'
    },
    copied_template: {
      data: {},
      message: '',
      status: 'loading'
    },
    template_updated: {
      data: {},
      message: '',
      status: 'loading'
    },
    deleted_file: {
      data: {},
      message: '',
      status: 'loading'
    },
    saved_as_template: {
      data: {},
      message: '',
      status: 'loading'
    }
  },
  getters: {
    templates: (state) => {
      return state.templates;
    },
    templates_dropdown: (state) => {
      return state.templates_dropdown;
    },
    templates_count: (state) => {
      return state.templates_count;
    },
    deleted_template: (state) => {
      return state.deleted_template;
    },
    copied_template: (state) => {
      return state.copied_template;
    },
    template_updated: (state) => {
      return state.template_updated;
    },
    deleted_file: (state) => {
      return state.deleted_file;
    },
    saved_as_template: (state) => {
      return state.saved_as_template;
    }
  },
  mutations,
  actions
};
